import React, {Component} from "react";
import StatistikComponent from "../components/StatistikComponent";

export class Statistik extends Component{
    render(){
        return(
            <StatistikComponent />
        )
    }
}

export default Statistik;